// extracted by mini-css-extract-plugin
module.exports = {"container":"LMK2C","container_static":"_951Ma","block":"YZQrW","block_static":"Fb5WS","position_fixed":"hUfMt","position_bottom":"xXTxr","iconFavorite":"_3OcyT","text":"uER8l"};